import * as React from 'react';
import Box from '@mui/material/Box';
import { getAbsoluteHost } from 'utils/commonFunc';

export default function H264LivePlayerWW(props) {
    const {
        url,
        poster,
    } = props;

    const videoRef = React.useRef(null);

    React.useEffect(() => {
        if (!url)
            return;

        const canvasParent = videoRef.current;
        const canvas = document.createElement('canvas');
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.verticalAlign = 'bottom';
        canvasParent.appendChild(canvas);
        const ofc = canvas.transferControlToOffscreen()        
        const ww = new Worker(getAbsoluteHost('scripts/http-live-player-worker.js'));
        ww.postMessage({
            cmd:'init',
            canvas: ofc
        }, [ofc]);
        ww.postMessage({
            cmd:'connect',
            url:url
        });
        return () => {
            ww.postMessage({
                cmd:'disconnect'
              });
              canvasParent.removeChild(canvas);
        }
    }, [url]);

    const childrenProps = () => {
        const copy = { ...props }
        delete copy.url;
        return copy
    }

    const posterStyle = poster ? {backgroundImage: `url(${poster})`, backgroundSize: 'cover'} : {};

    return (
        <Box ref={videoRef} sx={{width: '100%', height: '100%', ...posterStyle}} {...childrenProps()}>
            {/* <canvas style={{width:'100%', height:'100%', backgroundColor:'blue', verticalAlign:'bottom'}}/> */}
        </Box>
    )
}